import { RichTextEditor as MantineRichTextEditor, RichTextEditorControlProps } from "@mantine/tiptap";
import clsx from "clsx";
import { FunctionComponent } from "react";
import styles from "../rich-text-editor.module.scss";
import { faBold } from "@fortawesome/pro-solid-svg-icons";
import { Icon } from "../../icon";
import { useEditorDisabled } from "../use-editor-disabled";

const BoldIcon = () => <Icon icon={faBold} size="xs" />;

export const Bold: FunctionComponent<RichTextEditorControlProps> = ({ className, disabled, ...other }) => {
    const effectiveDisabled = useEditorDisabled(disabled);
    return (
        <MantineRichTextEditor.Bold
            className={clsx(styles["control"], className)}
            disabled={effectiveDisabled}
            {...other}
            icon={BoldIcon}
        />
    );
};

Bold.displayName = "RichTextEditor.Bold";
